$(() => {
  const toggle_more_than_one_authority = () => {
    const fade = 400;

    if ($('#more-than-one-authority').val() === 'Y') {
      $('.reduce-time-managing-payment').slideDown(fade);
      $('#fte-managing-payment-wrapper').slideDown(fade);
      $('#monthly-hours-managing-payment-wrapper').slideDown(fade);
    } else {
      $('.reduce-time-managing-payment').slideUp(fade);
      $('#fte-managing-payment-wrapper').slideUp(fade);
      $('#monthly-hours-managing-payment-wrapper').slideUp(fade);
    }
  };

  const toggle_discount = () => {
    const fade = 400;

    if ($('#discounts-from-authorities').val() === 'N') {
      $('.qualify-for-volume-discounts').slideDown(fade);
    } else {
      $('.qualify-for-volume-discounts').slideUp(fade);
    }
  };

  toggle_more_than_one_authority();
  $('#more-than-one-authority').change(() => toggle_more_than_one_authority());

  toggle_discount();
  $('#discounts-from-authorities').change(() => toggle_discount());
});
